export default __webpack_public_path__ + "static/media/bibooTextVertical.e7b135e4.png";